"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsentPolicy = void 0;
var env_1 = require("./env");
var constants_1 = require("../constants");
var getConsentPolicyDetails = function () {
    return env_1.requestGlobal(function (_a) {
        var consentPolicyManager = _a.consentPolicyManager, Wix = _a.Wix;
        var context = (Wix && Wix.Utils) || consentPolicyManager;
        return (context &&
            typeof context.getCurrentConsentPolicy === 'function' &&
            context.getCurrentConsentPolicy());
    });
};
exports.getConsentPolicy = function (consentPolicyDetails) {
    if (consentPolicyDetails === void 0) { consentPolicyDetails = getConsentPolicyDetails(); }
    return (consentPolicyDetails && consentPolicyDetails.policy) || constants_1.DefaultConsentPolicy;
};
//# sourceMappingURL=consent-policy.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/web-bi-logger/dist/src/lib/consent-policy.js
// module id = 207
// module chunks = 0 1